export default "__VITE_ASSET__0c994a7a__"